import React from "react";
import { Grid, Typography, Box, useTheme } from "@mui/material";
import { CompanyDetails } from "../../../../../../types/companies-managment/Company";
import MainCard from "../../../../../../components/MainCard";

interface CompanyEmployeeInfoProps {
  company: CompanyDetails;
}

const CompanyEmployeeInfo: React.FC<CompanyEmployeeInfoProps> = ({
  company,
}) => {
  const theme = useTheme();
  return (
    <MainCard title="Recruitment Officer">
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          padding: "1rem",
          gap: "1rem",
        }}
      >
        {/* <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
          <Typography color="GrayText" sx={{  width: "20%" }}>
            company_profile_id :
          </Typography>
          <Link
            style={{ color: theme.palette.primary.main }}
            to={`user/${company?.employee?.company_profile_id}`}
          >
            {company?.employee?.company_profile_id}
          </Link>
        </Box> */}
        {company?.employee?.full_name && (
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography color="GrayText" sx={{ width: "20%" }}>
              Full Name :
            </Typography>
            <Typography sx={{ width: "80%" }}>
              {company?.employee?.full_name}
            </Typography>
          </Box>
        )}
        {company?.employee?.position && (
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography color="GrayText" sx={{ width: "20%" }}>
              Position :
            </Typography>
            <Typography sx={{ width: "80%" }}>
              {company?.employee?.position}
            </Typography>
          </Box>
        )}
        {company?.employee?.mobile && (
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography color="GrayText" sx={{ width: "20%" }}>
              Mobile :
            </Typography>
            <Typography sx={{ width: "80%" }}>
              {company?.employee?.mobile}
            </Typography>
          </Box>
        )}
        {company?.employee?.phone && (
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography color="GrayText" sx={{ width: "20%" }}>
              Phone :
            </Typography>
            <Typography sx={{ width: "80%" }}>
              {company?.employee?.phone}
            </Typography>
          </Box>
        )}
        {company?.employee?.employee_email && (
          <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
            <Typography color="GrayText" sx={{ width: "20%" }}>
              Email :
            </Typography>
            <Typography sx={{ width: "80%" }}>
              {company?.employee?.employee_email}
            </Typography>
          </Box>
        )}
      </Grid>
    </MainCard>
  );
};

export default CompanyEmployeeInfo;
